export default __webpack_public_path__ + "static/media/download-app-img-id.d510d7a1.webp";